import React, {useRef, useEffect} from "react";
import * as Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import * as HighchartsExporting from "highcharts/modules/exporting";
require("highcharts/modules/accessibility")(Highcharts);
HighchartsExporting(Highcharts);
Highcharts.setOptions({
  lang: {
    thousandsSep: ','
  }
});

(function(H) {
    function stopEvent(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        if (e.stopPropagation) {
          e.stopPropagation();
        }
        e.cancelBubble = true;
      }
    }
  
    //the wrap
    H.wrap(H.Chart.prototype, 'render', function(proceed) {
      var chart = this,
        mapNavigation = chart.options.mapNavigation;
  
      proceed.call(chart);
  
      // Add the mousewheel event
      H.addEvent(chart.container, 'wheel', function(event) {
  
        var delta, extr, step, newMin, newMax, axis = chart.xAxis[0];
        var dataMax = chart.xAxis[0].dataMax,
          dataMin = chart.xAxis[0].dataMin,
          newExtrMin,
          newExtrMax;
  
        var e = chart.pointer.normalize(event);
        delta = e.detail || -(e.deltaY / 120);
        delta = delta < 0 ? 1 : -1;
  
        if (chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop)) {
          extr = axis.getExtremes();
          step = (extr.max - extr.min) / 5 * delta;
  
          if ((extr.min + step) <= dataMin) {
            newExtrMin = dataMin;
            newExtrMax = extr.max;
          } else if ((extr.max + step) >= dataMax) {
            newExtrMin = extr.min;
            newExtrMax = dataMax;
          } else {
            newExtrMin = extr.min + step;
            newExtrMax = extr.max + step;
          }
          axis.setExtremes(newExtrMin, newExtrMax, true, false);
        }
        stopEvent(event);
        return false;
      });
    });
  }(Highcharts));

export const MainChart = (props) => {
    const primaryOptions = {
        chart: {
          type: "bar",
          height: 520,
          backgroundColor: "var(--card_body_color)",
          color: "var(--text_color)",
        },
        title: {
          text: "Staffing hours",
          style: {
            textOutline: false,
            color: "var(--text_color)",
          },
        },
        xAxis: {
          type: "category",
          min: 0,
          max: 2,
          categories: props.categories,
          gridLineWidth: 1,
          tickInterval: 1,
          tickmarkPlacement: "between",
          labels: {
            style: {
              textOutline: false,
              color: "var(--text_color)",
            },
          },
          title: {
            text: null,
            style: {
              textOutline: false,
              color: "var(--text_color)",
            },
          },
          scrollbar: {
            enabled: true,
          },
          tickLength: 0,
          tickWidth: 1,
          labels: {
            style: {
              textOutline: false,
              color: "var(--text_color)",
            },
          },
        },
        yAxis: {
          min: -1000,
          max: 500,
          title: {
            align: "high",
            style: {
              textOutline: false,
              color: "var(--text_color)",
            },
          },
          labels: {
            style: {
              textOutline: false,
              color: "var(--text_color)",
            },
          },
        },
        colors: props.colors,
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
              colorByPoint: true,
              style: { textOutline: false, color: "var(--text_color)" },
            },
          },
          series: {
            pointWidth: 10,
            borderWidth: 0,
          },
        },
        legend: {
          enabled: true,
          itemStyle: {
            textOutline: false,
            color: "var(--text_color)",
          },
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: true,
          chartOptions: {
            xAxis: [{
              max: null
            }]
          }
        },
        series: props.primarySeries,
      };

      const chartComponent = useRef(null)
      useEffect(() => {
        console.log("CHART PROPS: ", props)
        const chart = chartComponent.current.chart;
        const chartSVG = chart.getSVG();
        props.chartref(chartSVG)
      }, []);

    return(
        <div className="chart-container staffing">
            <HighchartsReact
                ref={chartComponent}
                highcharts={Highcharts}
                options={primaryOptions}
            />
        </div>
    )
}